import { render, staticRenderFns } from "./TheHeaderAccount.vue?vue&type=template&id=ef746d3a&"
import script from "./TheHeaderAccount.vue?vue&type=script&lang=js&"
export * from "./TheHeaderAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports